module.exports = __webpack_public_path__ + "assets/success-icon.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/success-icon.png
// module id = 211
// module chunks = 0